import { withForm } from '@/core/form/withForm';
import { SvySwitch } from '@/components/savory/SvySwitch';

export const Switch = withForm(SvySwitch);
